import { SvgIcon } from '@mui/material';

/** Logo do Windows (quatro painéis). */
export function WindowsLogoIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path d="M3 5.547 10.734 4.5V11.25H3V5.547zm0 12.703 7.734 1.031V12.75H3v5.5zm9.984 1.266L21 20.25V12.75h-8.016v6.766zm0-14.062L21 3.75v7.5h-8.016V5.454z" />
        </SvgIcon>
    );
}

/** Ícone genérico de Linux (pinguim simplificado / Tux-like mark). */
export function LinuxLogoIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path d="M12.5 2c-1.1 0-2 .7-2.3 1.7-.9.3-1.7 1.1-1.7 2.3 0 .4.1.8.3 1.1C7.5 8.1 6.5 10 6.5 12.2c0 2.4 1.2 4.4 3 5.5-.2.5-.3 1-.3 1.5 0 1.9 1.3 3.3 3.3 3.3.7 0 1.3-.2 1.8-.5.5.3 1.1.5 1.8.5 2 0 3.3-1.4 3.3-3.3 0-.5-.1-1-.3-1.5 1.8-1.1 3-3.1 3-5.5 0-2.2-1-4.1-2.3-5.1.2-.3.3-.7.3-1.1 0-1.2-.8-2-1.7-2.3C14.5 2.7 13.6 2 12.5 2zm0 2c.3 0 .5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5.2-.5.5-.5zm-2.2 2.2c.4 0 .7.3.7.7s-.3.7-.7.7-.7-.3-.7-.7.3-.7.7-.7zm4.4 0c.4 0 .7.3.7.7s-.3.7-.7.7-.7-.3-.7-.7.3-.7.7-.7zM9.2 11.5c.6 0 1.1.5 1.1 1.1S9.8 13.7 9.2 13.7 8.1 13.2 8.1 12.6s.5-1.1 1.1-1.1zm5.6 0c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1-1.1-.5-1.1-1.1.5-1.1 1.1-1.1z" />
        </SvgIcon>
    );
}

